import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { useStore } from 'hooks/useStore';

import css from './styles.module.css';

const CompactViewButton = () => {
  const {
    ui: { isCompactPrettyLoad, setIsCompactPrettyLoad },
    app: { i18n },
  } = useStore();

  const handleClick = () => {
    setIsCompactPrettyLoad(!isCompactPrettyLoad);
  };

  return (
    <div className={css.container}>
      <span className={css.label}>{i18n.app.view}</span>

      <button className={css.switchButton} onClick={handleClick}>
        <span
          className={cn(css.switchIcon_default, {
            [css.switchIcon_enabled]: !isCompactPrettyLoad,
          })}
        ></span>
      </button>

      <button className={css.switchButton} onClick={handleClick}>
        <span
          className={cn(css.switchIcon_compact, {
            [css.switchIcon_enabled]: isCompactPrettyLoad,
          })}
        ></span>
      </button>
    </div>
  );
};

const connected = observer(CompactViewButton);

export { connected as CompactViewButton };
